<template>
  <div class="interview-success-message text-center py-6">
    <v-icon color="success" size="64" class="mb-4">mdi-check-circle</v-icon>
    <div class="text-h6 mb-2">{{ title }}</div>
    <div class="grey--text">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: 'InterviewSuccessMessage',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.interview-success-message {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
